import { IDepot } from './../../../interfaces/models';
import { Injectable } from '@angular/core';
import { DataService } from 'src/app/services/http/data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DepotService extends DataService {

  constructor(
    http: HttpClient
  ) {
    super(http);
  }

  create(depot: IDepot) {
    return this.post(depot, '?ctrl=depot&action=creer');
  }
  supprimer(id: any) {
    return this.delete(id, '?ctrl=depot&action=supprimer');
  }

  updateDepot(depot: IDepot) {
    return this.update(depot, '?ctrl=depot&action=modifier');
  }
}
